import type { DashboardConfig, DashboardVariant } from '@practium/features/dashboard';
import type { DashboardResponse } from '@practium/features/api';
import type { BindingUserApiResponse } from '@practium/features/users';
import { getConsultantDashboardConfig } from '../config/getConsultantDashboardConfig';
import { getFarmerDashboardConfig } from '../config/getFarmerDashboardConfig';
import { getCompanyDashboardConfig } from '../config/getCompanyDashboardConfig';

const ROLE_LABELS: Record<string, string> = {
	farmer: 'Agricultor',
	consultant: 'Consultor',
	company: 'Empresa',
	admin: 'Administrador',
	master: 'Master',
};

const mapBindingUserToSummary = (bindingUser?: BindingUserApiResponse | null) => {
	if (!bindingUser) return undefined;

	return {
		id: bindingUser._id,
		fullName: `${bindingUser.name} ${bindingUser.surName ?? ''}`.trim(),
		roleLabel: ROLE_LABELS[bindingUser.role ?? ''] ?? 'Usuario',
		email: bindingUser.email,
		document: bindingUser.document,
		phoneNumber: bindingUser.phoneNumber,
		status: bindingUser.status,
		avatarUrl: bindingUser.avatar?.url ?? bindingUser.profileImage ?? undefined,
	};
};

export const getDashboardConfig = (
	variant: DashboardVariant,
	navigate: (path: string) => void,
	data?: DashboardResponse,
	bindingUser?: BindingUserApiResponse | null
): DashboardConfig => {
	const dashboardConfigs: Record<DashboardVariant, DashboardConfig> = {
		farmer: getFarmerDashboardConfig(data?.dashboardType === 'farmer' ? data : undefined),
		consultant: getConsultantDashboardConfig(data?.dashboardType === 'consultant' ? data : undefined),
		company: getCompanyDashboardConfig(navigate, data?.dashboardType === 'company' ? data : undefined),
		admin: getCompanyDashboardConfig(navigate, data?.dashboardType === 'company' ? data : undefined)
	};

	return {
		...dashboardConfigs[variant],
		userSummary: mapBindingUserToSummary(bindingUser),
	};
};
